export default __webpack_public_path__ + "CircularCustCapNum-Black.182350cd7e6d7d49c1935b09accc1ee6.woff";